/** Validação de palavra-chave (espelha regulatory/keyword_search.py). */
export function sanitizeSearchKeyword(raw: string | null | undefined): string | null {
  if (!raw || !String(raw).trim()) return null;
  let core = String(raw).trim().replace(/\s+/g, ' ');
  const isLetter = (ch: string) => /\p{L}/u.test(ch);
  while (core && !isLetter(core[0]!)) core = core.slice(1);
  while (core && !isLetter(core[core.length - 1]!)) core = core.slice(0, -1);
  // Letras e espaços internos: permite frases ("Ministério do Meio Ambiente").
  if (!/^[\p{L}\s]+$/u.test(core)) return null;
  const letters = (core.match(/\p{L}/gu) || []).length;
  if (letters < 3) return null;
  return core;
}

export function normalizeKeywordKey(value: string): string {
  return value.trim().toLowerCase();
}

export const KEYWORD_VALIDATION_HINT =
  'Use ao menos 3 letras. Palavras ou frases são aceitas; sem números ou símbolos.';

/** Escopo da busca/monitoramento por palavra-chave (ementa + título, sem PDF). */
export const KEYWORD_SEARCH_SCOPE_TITLE = 'Escopo da busca';

export const KEYWORD_SEARCH_SCOPE_INFO =
  'A palavra-chave busca apenas no título e na ementa da norma gravados no sistema. Não pesquisa o texto completo do documento (PDF, artigos ou corpo integral).';
